export const environment = {
  production: true,
  appVersion: '1.0',
  allowedOrigins: [
    {
      "type": "local",
      "url": "https://localhost:44305",
      "redirect": null,
      "loginPage": "index.html"
    },
    {
      "type": "dev",
      "url": "http://sdc6001app023:8010",
      "redirect": "http://sdc6001app023:8001/cgaDirecta.cga.pt/cgaLogin.asp?redirect_uri=http%3A%2F%2Fsdc6001app023:8010%2FNBWebCGA.Web",
      "loginPage": null
    },
    {
      "type": "dev_cga",
      "url": "dcgapedidos.cga.pt",
      "redirect": "https://dcgadirecta.cga.pt/cgaLogin.asp?redirect_uri=http%3A%2F%2Fsdc6001app023:8010%2FNBWebCGA.Web",
      "loginPage": null
    },
    {
      "type": "dev_upgrade",
      "url": "http://sdc6001app023:8022",
      "redirect": "http://sdc6001app023:8014/cgaDirecta.cga.pt/cgaLogin.asp?redirect_uri=http%3A%2F%2Fsdc6001app023:8010%2FNBWebCGA.Web",
      "loginPage": "index.html"
    },
    {
      "type": "dev_nsi",
      "url": "http://sdc6001app023:8033",
      "redirect": "https://backoffice.dev.nprd.nsi.gcp.cga.pt/",
      "loginPage": null
    },
    {
      "type": "int",
      "url": "https://icgapedidos.cga.pt",
      "redirect": "https://icgadirecta.cga.pt/cgaLogin.asp?redirect_uri=https%3A%2F%2Ficgapedidos.cga.pt",
      "loginPage": null
    },
    {
      "type": "int_login",
      "url": "https://icgapedidos2.cga.pt",
      "redirect": "https://icgadirecta.cga.pt/cgaLogin.asp?redirect_uri=https%3A%2F%2Ficgapedidos.cga.pt",
      "loginPage": "index.html"
    },
    {
      "type": "int_nsi",
      "url": "https://icgapedidos3.cga.pt",
      "redirect": "https://backoffice.sit.nprd.nsi.gcp.cga.pt/",
      "loginPage": null
    },
    {
      "type": "qld",
      "url": "https://qcgapedidos.cga.pt",
      "redirect": "https://qcgadirecta.cga.pt/cgaLogin.asp?redirect_uri=https%3A%2F%2Fqcgapedidos.cga.pt",
      "loginPage": null
    },
    {
      "type": "qld_login",
      "url": "https://qcgapedidos2.cga.pt",
      "redirect": "https://qcgadirecta.cga.pt/cgaLogin.asp?redirect_uri=https%3A%2F%2Fqcgapedidos.cga.pt",
      "loginPage": "index.html"
    },
    {
      "type": "qld_nsi",
      "url": "https://qcgapedidos3.cga.pt",
      "redirect": "https://backoffice.uat.nprd.nsi.gcp.cga.pt/",
      "loginPage": null
    },
    {
      "type": "prd",
      "url": "https://cgapedidos.cga.pt",
      "redirect": "https://www.cga.pt/login?redirect_uri=https%3A%2F%2Fcgapedidos.cga.pt",
      "loginPage": null
    }
  ]


};
